// extracted by mini-css-extract-plugin
export default {"container":"component_form_table_container__HtCnf","checkboxGroup":"component_form_table_checkboxGroup__tuCpU","subLabel":"component_form_table_subLabel__7aLpQ"};